// extracted by mini-css-extract-plugin
module.exports = {"container":"loadingspinner_container__36hK2","containerBg":"loadingspinner_containerBg__1bkHm","box":"loadingspinner_box__2iyCB","spinner":"loadingspinner_spinner__FRJfU"};